import { Severity, usePushNotifications } from 'services/NotificationService';
import { useMutation } from '@apollo/react-hooks';
import {
  CreatePixelTrackingAppMutation,
  CreatePixelTrackingAppMutationVariables
} from './__generated__/CreatePixelTrackingAppMutation';
import { CREATE_PIXEL_APP_MUTATION } from './createPixelApp.mutation';

type MutationProps = {
  onStart?: () => void;
  onCompleted?: () => void;
  onError?: () => void;
};

export const useCreatePixelApp = ({ onStart, onCompleted, onError }: MutationProps) => {
  const notify = usePushNotifications();
  const [createPixelApp] = useMutation<CreatePixelTrackingAppMutation, CreatePixelTrackingAppMutationVariables>(
    CREATE_PIXEL_APP_MUTATION,
    {
      refetchQueries: ['PixelAppsQuery'],
      onCompleted: (data) => {
        if (data.createPixelTrackingApp?.errors?.length) {
          if (onError) onError();
          notify({
            title: 'Pixel App was not created',
            message: data.createPixelTrackingApp.errors[0],
            severity: Severity.ERROR
          });
        } else {
          if (onCompleted) onCompleted();
          notify({
            title: 'Success',
            message: 'Pixel App was created successfully!',
            severity: Severity.SUCCESS
          });
        }
      },
      onError: () => onError && onError()
    }
  );
  return (variables: CreatePixelTrackingAppMutationVariables) => {
    if (onStart) onStart();
    createPixelApp({
      variables
    });
  };
};
